// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TenantUser, TenantUserRemovalInfo } from 'src/app/model/platformuser.model';
import { TenantUserEdit } from 'src/app/component/user-management/user-management.component';
import { AppEnvironmentService } from '../app-environment.service';

const contentType = 'application/json';

@Injectable({ providedIn: 'root' })
export class TenantUserService {

    constructor(private readonly http: HttpClient, private readonly appEnvironmentService: AppEnvironmentService) { }

    private get baseApiUrl(): string { return this.appEnvironmentService.baseApiUrl; }

    getTenantUsers(tenantId: number): Observable<TenantUser[]> {
        const accessToken = localStorage.getItem('access_token');
        const url = this.baseApiUrl + `tenants/${tenantId}/users`;
        const headers = new HttpHeaders({ 'Content-Type': contentType, 'Authorization': `Bearer ${accessToken}` });
        return this.http.get<TenantUser[]>(url, { headers }).pipe(
            map(response => Array.isArray(response) ? response.map(entry => TenantUser.FromAPI(entry)) : [])
        );
    }

    getTenantUserRemovalInfo(tenantId: number, userId: number): Observable<TenantUserRemovalInfo> {
        const accessToken = localStorage.getItem('access_token');
        const url = this.baseApiUrl + `tenants/${tenantId}/users/${userId}/removalInfo`;
        const headers = new HttpHeaders({ 'Content-Type': contentType, 'Authorization': `Bearer ${accessToken}` });
        //@ts-ignore
        return this.http.get<TenantUserRemovalInfo>(url, { headers });
    }

    updateTenantUser(editTenantUserData: TenantUserEdit) {
        const accessToken = localStorage.getItem('access_token');
        const url = this.baseApiUrl + `tenants/${editTenantUserData.tenantProfile.tenantId}/users/${editTenantUserData.id}`;
        const headers = new HttpHeaders({ 'Content-Type': contentType, 'Authorization': `Bearer ${accessToken}` });
        const body = { role: editTenantUserData.tenantProfile.role, userDisplayCosts: editTenantUserData.tenantProfile.userDisplayCosts };
        return this.http.put<any>(url, body, { headers });
    }

    removeTenantUser(editTenantUserData: TenantUserEdit) {
        const accessToken = localStorage.getItem('access_token');
        const url = this.baseApiUrl + `tenants/${editTenantUserData.tenantProfile.tenantId}/users/${editTenantUserData.id}`;
        const headers = new HttpHeaders({ 'Content-Type': contentType, 'Authorization': `Bearer ${accessToken}` });
        return this.http.patch<any>(url, { env: this.appEnvironmentService.appEnvData.env }, { headers });
    }
}
